module.exports = __webpack_public_path__ + "media/images/email/instagram-5d2288d871f22ced7aaec1d836e81969.png";